export default "__VITE_ASSET__CMARs710__"